import { truncate } from "lodash";
import type { BloodTestPackage } from "../../../models";

type BloodTestsListProps = {
  bloodTests: BloodTestPackage["bloodTests"];
};

export const BloodTestsList = ({ bloodTests }: BloodTestsListProps) => (
  <ul className="flex flex-wrap gap-2">
    {[...bloodTests]
      .sort((a, b) => a.name.length - b.name.length)
      .map(({ name }, index) => (
        <li
          // Local BloodTest has no id; names are effectively unique within a package, index guards duplicates.
          key={`${name}-${index}`}
          className="inline-block rounded-full bg-[#F5F5F4] px-3 py-1 text-foreground text-sm max-lg:mr-1 lg:px-4 lg:py-1.5 lg:text-base"
        >
          <span>{truncate(name, { length: 42 })}</span>
        </li>
      ))}
  </ul>
);
